import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import { ILogRequest, ILogsApiData } from "../../../_models/logger.model";


@Injectable({
  providedIn: "root",
})
export class LoggerService {
  constructor(private apiService: ApiService){}

  getAllLogs(request: ILogRequest) {
    let params = new HttpParams({
      fromObject: {
        page: String(request.page),
        limit: String(request.limit),
        ...(request.type && { level: request.type.toLowerCase() }),
        ...(request.search && { search: request.search }),
        ...(request.startDate && { startDate: request.startDate }),
        ...(request.endDate && { endDate: request.endDate }),
        ...(request.sort && { sortBy: request.sort }),
        ...(request.sortOrder && { sortOrder: request.sortOrder }),
        ...(request.includeDeleted && { includeDeleted: 'true' }),
      },
    });

    return this.apiService.get<ILogsApiData>({
      Url: "gossip/admin/logs",
      Params: params
    });
  }

  deleteLogs(logIds: string[]) {
    return this.apiService.put<{ logIds: string[] }, any>({
      Url: "gossip/admin/logs/delete",
      Body: { logIds }
    });
  }
}
